import React from 'react';
import { createRoot } from 'react-dom/client';
import { StandaloneApp } from './standalone/StandaloneApp';

const mountNode = document.getElementById('root');
if (!mountNode) {
  throw new Error('缺少文档应用挂载节点 #root');
}

createRoot(mountNode).render(
  <React.StrictMode>
    <StandaloneApp />
  </React.StrictMode>,
);
